export enum SOCKET_SERVICE_EVENT {
  /**
   * Recieves an event when the service is terminated
   */
  finished = 'service:finished',
  /**
   * Recieves an event when the service is started
   */
  started = 'service:started',
}
